import Renderer from "Renderer";
import ReactDOM from "react-dom";
import "./assets/css/App.css";

ReactDOM.render(<Renderer />, document.getElementById("root"));
